import { differenceInCalendarDays } from 'date-fns';

export function getDaysBetween(dateFrom: Date, dateTo: Date): number {
  return differenceInCalendarDays(dateTo, dateFrom) + 1;
}
